import { render, staticRenderFns } from "./EditUserNameModal.vue?vue&type=template&id=6ee9dd20"
import script from "./EditUserNameModal.vue?vue&type=script&lang=js"
export * from "./EditUserNameModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports